// ═══════════════════════════════════════════════════════
// LocalBotTransport — thin ITransport stub for bot matches
// All bot AI (unit sends, tower upgrades) lives in MatchEngine._tickBot.
// This class exists only to satisfy the ITransport interface contract.
// ═══════════════════════════════════════════════════════
import type { ITransport, GameEvent } from '@interfaces/index';

export class LocalBotTransport implements ITransport {
  private receiveCallbacks: ((event: GameEvent) => void)[] = [];

  constructor(
    _availableUnitIds: string[] = [],
    _availableTowerIds: string[] = [],
    _botPlayerId = 'bot1'
  ) {
    // Parameters kept for API compatibility; bot logic is in MatchEngine.
  }

  async connect(): Promise<void> {
    console.log('[LocalBotTransport] Bot connected — AI handled by MatchEngine');
  }

  send(_event: GameEvent): void {
    // No-op: bot doesn't relay events to a remote peer.
  }

  onReceive(cb: (event: GameEvent) => void): void {
    this.receiveCallbacks.push(cb);
  }

  disconnect(): void {
    this.receiveCallbacks = [];
  }
}
